<template>
  <v-data-table
    height="55vh"
    fixed-header
    :headers="headers"
    :items="this.$store.state.menuTree"
    :search="search"
    sort-by="rowId"
    :footer-props="{
      'items-per-page-options': [5, 10, 15, 20]
    }"
    :items-per-page="page"
    class="elevation-1"
    @update:items-per-page="getItemPerPage"
  >
    <!-- <template v-slot:item.limit="{ item }"> -->
    <template v-slot:[`item.limit`]="{ item }">
      <div v-if="editBtn == false">{{ item.limit.name }}</div>
      <div v-else-if="editBtn == true" class="ma-0 pa-0">
        <v-select
          v-model="item.limit"
          :items="authType"
          item-text="name"
          item-value="value"
          return-object
          dense
          outlined
          @change="printValue(`${item.limit.value}`, item.sysGroupId, item.sysMenuId)"
        ></v-select>
      </div>
    </template>
    <template v-slot:top>
      <div class="pa-5">
        <div class="row viewList">
          <div class="col-sm-12 col-md-4 col-lg-3">
            <!-- :hint="`選單功能, ${select.value}`" -->
            <v-select
              v-model="select"
              :items="$store.state.userGroup"
              item-text="name"
              item-value="value"
              persistent-hint
              label="請選擇"
              return-object
              single-line
            ></v-select>
            <!-- <v-select :items="items" v-model="select" label="查詢條件" dense outlined ></v-select> -->
          </div>
          <div class="col-sm-12 col-md-4 col-lg-1">
            <v-btn
              large
              color="primary"
              dark
              class="mb-2"
              aria-setsize="16px"
              block
              @click="query()"
              >查詢</v-btn
            >
          </div>
          <div class="col-sm-12 col-md-4 col-lg-1" v-if="editBtn == false">
            <v-btn
              large
              color="primary"
              dark
              class="mb-2"
              aria-setsize="16px"
              block
              @click="editAuth()"
              >編輯</v-btn
            >
          </div>
          <div class="col-sm-12 col-md-4 col-lg-1" v-if="editBtn == true">
            <v-btn
              large
              color="green"
              dark
              class="mb-2"
              aria-setsize="16px"
              block
              @click="cancelAuth()"
              >取消</v-btn
            >
          </div>
          <div class="col-sm-12 col-md-4 col-lg-1" v-if="editBtn == true">
            <v-btn
              large
              color="blue"
              dark
              class="mb-2"
              aria-setsize="16px"
              block
              @click="saveAuth()"
              >儲存</v-btn
            >
          </div>
        </div>
      </div>
    </template>

    <template v-slot:no-data></template>
  </v-data-table>
</template>
<script>
export default {
  data: () => ({
    editBtn: false,
    valid: true,
    search: '',
    dialog: false,
    disabled: 0,
    select: { name: '系統管理者', value: '1' },
    rows: 10,
    page: 10,
    authType: [
      { name: '啟用', value: '1' },
      { name: '禁止', value: '0' }
    ],
    editedItem: [],
    changedItem: [],
    disabled: true,
    headers: [
      //{ text: '', value: 'rowId', sortable: false },
      { text: '父選單代號', value: 'sysParentId' },
      { text: '父選單名稱', value: 'parentMenuName' },
      { text: '選單代號', value: 'sysMenuId' },
      { text: '選單名稱', value: 'menuName' },
      { text: '選單權限', value: 'limit' },
      { text: '建立人員', value: 'creatUser' },
      { text: '建立時間', value: 'creatTime' },
      { text: '異動人員', value: 'actUser' },
      { text: '異動時間', value: 'actTime' }
    ],
    tmpAuth: []
  }),
  methods: {
    printValue(value, groupId, menuId) {
      let row = {}
      row.value = value
      row.groupId = groupId
      row.menuId = menuId
      this.changedItem.push(row)
    },
    editAuth() {
      this.changedItem = []
      this.editBtn = true
      this.disabled = 0
      //this.editedItem = this.$store.state.menuTree
    },
    cancelAuth() {
      this.editBtn = false
      this.changedItem = []
      this.query()
      this.disabled = 1
    },
    saveAuth() {
      this.editBtn = false
      let url = this.$store.state.api + '/S00030/ActMenuLimit'
      this.disabled = 1
      if (this.changedItem.length === 0) {
        return
      }
      let data = Object.assign({
        changedItem: JSON.stringify(this.changedItem)
      })
      this.axios.post(url, this.qs.stringify(data)).then(res => {
        if (res.data.resultCode == '10') {
          this.changedItem = []
        } else {
          alert(res.data.error)
        }
      })
    },
    getItemPerPage(val) {
      this.rows = val
    },
    query() {
      let url = this.$store.state.api + '/S00030/QueryMenuLimit'
      let data = Object.assign({
        queryType: this.select,
        perPage: this.perPage,
        rowsPerPageItems: this.rowsPerPageItems
      })
      this.axios.post(url, this.qs.stringify(data)).then(res => {
        this.$store.state.menuTree.splice(0)
        if (res.data.resultCode == '10') {
          var rows = res.data.rows
          for (var i = 0; i < res.data.rows.length; i++) {
            var row = rows[i]
            row.limit = {
              name: row.limitName,
              value: row.limitId
            }
            this.$store.state.menuTree.push(row)
          }
        } else {
          alert(res.data.error)
        }
      })
    }
  },
  watch: {
    authType(val) {
      window.console.log(val)
    }
  }
}
</script>
<style>
.numer {
  flex: 0 0 auto;
  margin: 0;
  padding: 0;
}
.numer input {
  text-align: center;
}
.v-text-field__details {
  position: absolute;
  margin: 12px 100px;
}
</style>
